import VueRouter from 'vue-router'
import Auth from 'components/Auth'
import Account from 'components/Account'
import AccountMigrate from 'components/AccountMigrate'
import Buy from 'components/Buy'
import BuyLifetime from 'components/BuyLifetime'
import Features from 'components/Features'
import Pricing from 'components/Pricing'
import Home from 'components/Home'
import Download from 'components/Download'
import Disclaimer from 'components/Disclaimer'
import Recover from 'components/Recover'
import Subscription from 'components/Subscription'
import AffiliateRegister from 'components/AffiliateRegister'
import AffiliateSales from 'components/AffiliateSales'
import PrivacyPolicy from 'components/PrivacyPolicy'
import TermsOfUse from 'components/TermsOfUse'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: 'PTDefender'
    }
  },
  {
    path: '/a/:referral',
    name: 'home-referral',
    props: true,
    component: Home,
    meta: {
      title: 'PTDefender'
    }
  },
  {
    path: '/auth/:license',
    name: 'auth',
    props: true,
    component: Auth,
    meta: {
      title: 'PTDefender'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Auth,
    meta: {
      title: 'PTDefender'
    }
  },
  {
    path: '/account',
    name: 'account',
    props: true,
    component: Account,
    meta: {
      title: 'Account | PTDefender'
    }
  },
  {
    path: '/account/migrate',
    name: 'account-migrate',
    props: true,
    component: AccountMigrate,
    meta: {
      title: 'Account Migration | PTDefender'
    }
  },
  {
    path: '/features',
    name: 'features',
    component: Features,
    meta: {
      title: 'Features | PTDefender'
    }
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: Pricing,
    meta: {
      title: 'Pricing | PTDefender'
    }
  },
  {
    path: '/download',
    name: 'download',
    component: Download,
    meta: {
      title: 'Download | PTDefender'
    }
  },
  {
    path: '/privacy',
    name: 'privacy-policy',
    component: PrivacyPolicy,
    meta: {
      title: 'Privacy Policy | PTDefender'
    }
  },
  {
    path: '/disclaimer',
    name: 'disclaimer',
    component: Disclaimer,
    meta: {
      title: 'Disclaimer | PTDefender'
    }
  },
  {
    path: '/terms',
    name: 'terms',
    component: TermsOfUse,
    meta: {
      title: 'Terms of Service | PTDefender'
    }
  },
  {
    path: '/buy',
    name: 'buy',
    component: Buy,
    meta: {
      title: 'Buy Now | PTDefender'
    }
  },
  {
    path: '/buy/lifetime',
    name: 'buy-lifetime',
    component: BuyLifetime,
    meta: {
      title: 'Buy Now | PTDefender'
    }
  },
  {
    path: '/subscription/:id',
    name: 'subscription',
    component: Subscription,
    props: true,
    meta: {
      title: 'Edit Subscription | PTDefender'
    }
  },
  {
    path: '/recover',
    name: 'recover',
    component: Recover,
    meta: {
      title: 'Recover License | PTDefender'
    }
  },
  {
    path: '/affiliate/register',
    name: 'affiliate-register',
    component: AffiliateRegister,
    meta: {
      title: 'Affiliate Registration | PTDefender'
    }
  },
  {
    path: '/affiliate/sales',
    name: 'affiliate-sales',
    component: AffiliateSales,
    meta: {
      title: 'Affiliate Sales | PTDefender'
    }
  },
  {
    path: '/r/:referral',
    name: 'buy-referral',
    props: true,
    component: Buy,
    meta: {
      title: 'Buy Now | PTDefender'
    }
  }
]

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(from, to, savedPosition) {
    if (savedPosition) return savedPosition
    return { x: 0, y: 0 }
  }
})

router.afterEach(to => {
  document.title = to.meta.title || 'PTDefender'
})

export default router
